import { Alert } from 'components/Alert';
import { useContext, useEffect, useState } from 'react';
import { EarlyDayLogoGraphic } from 'graphics';
import { ModalBody } from 'components/Modal/ModalBody';
import { ModalActions } from 'components/Modal/ModalActions';
import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import { HiringUpdateFlowContext } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateContext';
import { HiringUpdateFlowSteps } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateFlow.constants';

export const FeedbackStep = () => {
  const [alertOpen, setAlertOpen] = useState(false);

  const { open, goToNextStep, step, error } = useContext(HiringUpdateFlowContext);

  useEffect(() => {
    if (step === HiringUpdateFlowSteps.FEEDBACK && !error) {
      setAlertOpen(true);
      setTimeout(() => {
        setAlertOpen(false);
        goToNextStep();
      }, 3000);
    }
  }, [step, error]);

  return error ? (
    <Modal size="sm" open={open && step === HiringUpdateFlowSteps.FEEDBACK} onClose={goToNextStep}>
      <ModalBody className="my-3">
        <p className="text-center">
          Please try again. If the error persists, contact our support team.
        </p>
      </ModalBody>

      <ModalActions>
        <Button type="button" size="lg" fullWidth onClick={goToNextStep}>
          OK
        </Button>
      </ModalActions>
    </Modal>
  ) : (
    <Alert open={alertOpen}>
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-8 h-8 bg-secondary-sky rounded">
          <EarlyDayLogoGraphic className="w-4 h-4" />
        </div>
        <p className="text-sm text-neutral-darker">Thanks a lot for your feedback!</p>
      </div>
    </Alert>
  );
};
